const allPlans = {
	type: {
		core: "core",
		veb: "veb"
	}
};

export const ALL_PLANS = allPlans;
